import { useState, useEffect } from 'react';

// Breakpoints
export const breakpoints = {
  mobile: 0,
  tablet: 768,
  laptop: 1024,
  desktop: 1200,
  large: 1440
};

export const useResponsive = () => {
  const [screenSize, setScreenSize] = useState({
    width: typeof window !== 'undefined' ? window.innerWidth : 1200,
    height: typeof window !== 'undefined' ? window.innerHeight : 800
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = screenSize.width < breakpoints.tablet;
  const isTablet = screenSize.width >= breakpoints.tablet && screenSize.width < breakpoints.laptop;
  const isLaptop = screenSize.width >= breakpoints.laptop && screenSize.width < breakpoints.desktop;
  const isDesktop = screenSize.width >= breakpoints.desktop && screenSize.width < breakpoints.large;
  const isLarge = screenSize.width >= breakpoints.large;

  const getResponsiveValue = (mobile, tablet, laptop, desktop, large) => {
    if (isLarge && large !== undefined) return large;
    if (isDesktop && desktop !== undefined) return desktop;
    if (isLaptop && laptop !== undefined) return laptop;
    if (isTablet && tablet !== undefined) return tablet;
    return mobile;
  };

  const getValueByBreakpoint = (values) => {
    const { mobile, tablet = mobile, laptop = tablet, desktop = laptop, large = desktop } = values;
    return getResponsiveValue(mobile, tablet, laptop, desktop, large);
  };

  return {
    screenSize,
    isMobile,
    isTablet,
    isLaptop,
    isDesktop,
    isLarge,
    getResponsiveValue,
    getValueByBreakpoint,
    breakpoint: isMobile ? 'mobile' : isTablet ? 'tablet' : isLaptop ? 'laptop' : isDesktop ? 'desktop' : 'large'
  };
};

export default useResponsive;